(ns manage.content-configuration-page.placeholder.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.ui.add-item :refer [generate-unique-id]]
            [common.ui.entity :refer [query-param->config]]
            [common.ui.list :as ui.list]
            [common.ui.store :as store]
            [manage.content-configuration-page.placeholder.db :as db]
            [manage.content-configuration-page.placeholder.type]
            [manage.content-configuration-page.view.list :as lv]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]))

(declare list-cfg)

(defn entity-view-cfg-placeholder-base
  [{p :eid :as placeholder}]
  {:entity/ref placeholder
   :entity/icon [:placeholder/icon p]
   :entity/label :placeholder/name
   :validation/schema :placeholder
   :validation/pull-pattern [:placeholder/name :placeholder/type]})

(defn define-structure-button [placeholder]
  [:> Button
   {:href @(rf/subscribe [:entity/link @(rf/subscribe [:collection-placeholder/query-params placeholder])])
    :start-icon ($ Icon "settings")
    :data-testid "btn-define-structure"
    :variant "text"}
   "Define structure"])

(defn entity-view-cfg [{p :eid :as placeholder}]
  (let [placeholder-type @(store/get-value placeholder :placeholder/type)]
    (cond-> (entity-view-cfg-placeholder-base placeholder)
      (= placeholder-type :collection)
      (assoc
       :entity/query-param [:collection-placeholder/query-params placeholder]
       :list-item/details [define-structure-button placeholder]
       :entity/content
       [lv/view
        (merge (entity-view-cfg-placeholder-base placeholder)
               {:entity/context-menu [{:label "Delete placeholder"
                                       :icon "delete"
                                       :on-click (fn [_]
                                                   (rf/dispatch [:ui.store/delete p
                                                                 :content-configuration/placeholder
                                                                 :placeholder/visualization-order])
                                                   (rf/dispatch [:side-menu/open :placeholders]))}]
                :list/add-item-cfg
                {:add-item/label "Add placeholder to collection structure"
                 :add-item/select-options [:placeholder/collection-type-options]
                 :add-item/add-fn
                 (fn [selected-type]
                   (rf/dispatch [:collection-placeholder/add-to-structure p
                                 (generate-unique-id :placeholder/name (str selected-type "-placeholder"))
                                 (keyword selected-type)]))}
                :list/items :collection-placeholder/structure
                :list/sort-by :placeholder/visualization-order
                :list/reorderable? true
                :list/->item-cfg entity-view-cfg})]))))

(defui add-placeholder-label []
  (let [missing-placeholders (db/use-missing-placeholders)]
    ($ Stack {:direction "row"
              :justifyContent "space-between"
              :alignItems "center"}
       ($ Typography {:component "label"
                      :fontWeight "600"}
          "Add placeholder")
       ($ Button {:onClick #(rf/dispatch [:manage.content-configuration-page.placeholder.db/add-from-template missing-placeholders])
                  :variant "text"
                  :data-testid "add-required-placeholders-button"
                  :sx #js {:py 0}
                  :disabled (empty? missing-placeholders)
                  :startIcon ($ Icon "add")}
          "Add required placeholders"))))

(defn list-cfg [cc]
  (lv/as-entity
   {:entity/ref cc
    :entity/icon "code"
    :entity/label "Placeholders"
    :validation/schema :content-configuration
    :validation/render-type :alert-list
    :validation/pull-pattern [{:content-configuration/placeholder [:placeholder/name :placeholder/type :collection-placeholder/structure]}]
    :list/add-item-cfg
    {:add-item/label ($ add-placeholder-label)
     :add-item/select-options [:placeholder/type-option]
     :add-item/dropdown-props {:data-testid "placeholder-select"}
     :add-item/add-fn
     (fn [selected-type]
       (rf/dispatch [:placeholder/create
                     (generate-unique-id :placeholder/name (str selected-type "-placeholder"))
                     (keyword selected-type)]))}
    :list/items :content-configuration/placeholder
    :list/sort-by :placeholder/visualization-order
    :list/reorderable? true
    :list/->item-cfg entity-view-cfg
    :list/empty-msg ($ ui.list/empty-msg {:title "Define your placeholders"}
                       ($ :p
                          "Your Adset requires a fallback version when no context is available,
                           or if the customer does not belong in any pre-defined categories.")
                       ($ :p
                          "To achieve a default version of your adset, give each placeholder a "
                          ($ ui.list/empty-msg-link {:menu :default-values} "default value")))}))

(defmethod query-param->config :collection-placeholder
  [{placeholder-name :name}]
  (some->
   @(rf/subscribe [:collection-placeholder/find-by-name placeholder-name])
   store/->DataScriptDBEntity
   entity-view-cfg))
